<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.414 7l5.293-5.293c.39-.39.39-1.023 0-1.414-.391-.39-1.023-.39-1.414 0L7 5.586 1.707.293c-.39-.39-1.023-.39-1.414 0-.39.391-.39 1.023 0 1.414L5.586 7 .293 12.293c-.39.391-.39 1.023 0 1.414.195.195.451.293.707.293.256 0 .512-.098.707-.293L7 8.414l5.293 5.293c.195.195.45.293.707.293.256 0 .512-.098.707-.293.39-.391.39-1.023 0-1.414L8.414 7z"
      clip-rule="evenodd"
    />
  </svg>
</template>
<script>
export default {
  name: 'CloseIcon',
};
</script>
<style lang="scss" scoped>
svg {
  color: #262626;
}
</style>
